

//#region imports
import React, { useEffect, useState } from "react"

// redux
import { resetSetBookingLocationFlags, selectSetBookingLocationStatus, setBookingLocation } from "_redux/slices/timeline/timeline-data";
import { selectDropOffLocations } from "_redux/slices/timeline/timeline-areas";

// bootstrap
import { Button, Col, Row } from "react-bootstrap";

// tremor
import { Subtitle } from "@tremor/react";
import { useDispatch, useSelector } from "react-redux";

// styling
import { Spacing, Colors } from "_styles";

// custom components
import { CustomSpinner } from "_components/atoms";

// icons
import { FaArrowRightLong } from "react-icons/fa6";
// drop down menu
import Select from "react-select";
import { setChangeLocModal } from "_redux/slices/utils/menu-context";
import { ar } from "date-fns/locale";

//#endregion

const UpdatePaxLocationModal = ({ passenger, showRemoveBtn = true }) => {

    //#region redux
    const dispatch = useDispatch()
    const dropOffLocations = useSelector(selectDropOffLocations);
    const setBookingLocationStatus = useSelector(selectSetBookingLocationStatus)
    //#endregion

    //#region state
    const [selectedDropOff, setSelectedDropOff] = useState(null)                    //  selected drop off location
    const [disableConfirm, setDisableConfirm] = useState(true)                      //  handle disable/enable confirm button
    const [currentLocation, setCurrentLocation] = useState("")                      //  current location of the passenger
    const [newDropedLocations, setNewDropedLocations] = useState([])                      //  current location of the passenger
    //#endregion
    //#region functions
    //TODO** REVIEW THIS
    // update pax location
    const confirm = () => {
        //getting value of selected new Location 
        const locationId = selectedDropOff.value;
        const activity = passenger.paxPositionInfo?.activity ?? passenger.originalBookingDoc?.paxPositionInfo?.activity ?? "Checked-in";
        const arrivalPax = passenger.flightBooking ? true : false;
        // create pax location object
        const paxLocation = {
            bookingId: passenger.originalBookingId ? passenger.originalBookingId : passenger._id,
            locationTitle: dropOffLocations.find((location) => location._id === locationId)?.title,
            location: locationId,
            activity: activity,
            time: new Date(),
            arrivalPax: arrivalPax,
        }
        dispatch(setBookingLocation(paxLocation))
    }


    // handle moving or removing passenger
    const handleRemovePax = () => {
        const confirmed = window.confirm(`Are you sure you want to remove this passenger from ${currentLocation}?`);
        if (confirmed) {
            const paxLocation = {
                bookingId: passenger.originalBookingId && passenger.bookingType !== "DUPLICATE" ? passenger.originalBookingId : passenger._id ? passenger._id : passenger.id,
                activity: "manually-removed",
                location: "manually-removed",
                locationTitle: "manually-removed",
                time: new Date(),
                checkInFlag: false
            }
            dispatch(setBookingLocation(paxLocation))
        }

    }

    // handle select drop off location
    const handleSelect = (location) => {
        setSelectedDropOff(location)
    }
    //#endregion

    //#region use effects

    useEffect(() => {
        if (setBookingLocationStatus === "succeeded") {
            dispatch(setChangeLocModal({ passenger: {}, show: false }));
            dispatch(resetSetBookingLocationFlags());
        }
    }, [setBookingLocationStatus])

    // monitor disable state change
    useEffect(() => {

        if (selectedDropOff !== null) {
            setDisableConfirm(false)
        }
        else {
            setDisableConfirm(true)
        }
    }, [selectedDropOff])

    useEffect(() => {
        if (passenger?.paxPositionInfo?.locationTitle) {
            setCurrentLocation(passenger?.paxPositionInfo?.locationTitle)
        };
        if (passenger?.isALTPickUp) {
            setCurrentLocation(passenger?.pickUpLocation?.name)
        }
        //remove curent location from new location list
        const newLocationList = dropOffLocations.filter(location => location._id !== passenger?.paxPositionInfo?.locationId)
        setNewDropedLocations(newLocationList)
    }, [passenger])

    //#endregion

    return (
        <>

            {/* spinner */}
            <Row>
                <Col xs={12} style={{ textAlign: "center", fontSize: "12px" }}>
                    <div style={{ height: "14px", display: "flex", justifyContent: "center", alignItems: "center", }}>
                        {setBookingLocationStatus === "loading" && <CustomSpinner style={{ color: Colors.PRM_LIGHT_BLUE }} />}
                    </div>
                </Col>
            </Row>

            <Row style={{ alignItems: "center" }}>

                {/* current location */}
                <Col xs={12} md={5}>
                    <div>
                        <Subtitle>Current Location</Subtitle>
                        <select value="" disabled style={{ height: Spacing.SCALE_50, width: "100%", marginTop: Spacing.SCALE_10, borderRadius: "5px", backgroundColor: "#d3d3d3", color: "#555", appearance: "none", WebkitAppearance: "none", MozAppearance: "none", paddingLeft: "10px" }}>
                            <option value="" style={{ fontWeight: 'bold' }}>{currentLocation}</option>
                        </select>
                    </div>
                </Col>

                {/* arrow */}
                <Col xs={12} md={2} style={{ textAlign: "center", fontSize: "24px", marginTop: Spacing.SCALE_40 }}>
                    <FaArrowRightLong color={Colors.PRM_LIGHT_BLUE} size={38} />
                </Col>

                {/* new location */}
                <Col xs={12} md={5}>
                    <div>
                        <Subtitle>New Location</Subtitle>
                        {/* drop down list of locations */}
                        <Select
                            value={selectedDropOff || null}
                            onChange={(selectedOption) => {
                                handleSelect(selectedOption)
                            }}
                            options={newDropedLocations?.map(loc => ({
                                value: loc._id,
                                label: loc.title
                            }))}
                            placeholder="Choose new location.."
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minWidth: "25%",
                                    borderRadius: "5px",
                                }),
                            }}
                            isClearable
                        />

                    </div>
                </Col>

            </Row>

            <Row className="mt-5">

                {showRemoveBtn && <Col xs={12} md={5}>

                    {/* remove passenger button */}
                    <Button
                        variant="outline-danger"
                        onClick={handleRemovePax}
                        style={{ width: "100%" }}
                        disabled={setBookingLocationStatus === "loading"}
                    >
                        {"Remove Passenger from " + currentLocation}
                    </Button>

                </Col>}

                <Col xs={12} md={showRemoveBtn ? 2 : 4} />

                {/* update Location button */}
                <Col xs={12} md={showRemoveBtn ? 5 : 4} style={{ justifyContent: "center", display: "flex", alignItems: "center" }}>

                    <Button
                        variant="primary"
                        disabled={disableConfirm}
                        onClick={confirm}
                        style={{ width: "100%" }}
                    >
                        {"Update Location"}
                    </Button>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs={12} style={{ textAlign: "center", fontSize: "14px" }}>
                    {setBookingLocationStatus === "failed" && <p style={{ color: Colors.TEXT_COLOR }} className="text-danger">There is something wrong, please try later!</p>}
                </Col>
            </Row>
        </>
    )
}


export default UpdatePaxLocationModal;